import firebase from 'firebase/app'
import 'firebase/firestore'
import md5 from 'blueimp-md5'
export default {
  state: {
    carritoHabilitado: true,
    cantidad: 0,
    productos: [],
    total: 0,
    subtotal: 0,
    descuento: 0,
    tipo: 'porcentaje',
    payU: false,
    paypal: false,
    info: {
      apiKey: 'ta0xOdHdangX7JaPljo4dCNXPw',
      apiLogin: '5Wo18eQAAWuMCF1',
      merchantId: '769919',
      accountId: '776600',
      total: null,
      currency: null,
      iva: null,
      subtotal: null,
      referenceCode: null,
      description: null,
      notifyUrl: null,
      paymentMethod: null,
      deviceSessionId: null,
      ipAddress: null,
      cookie: null,
      userAgent: null,
      signature: null,
      buyer: {
        fullName: null,
        emailAddress: null,
        contactPhone: null,
        dniType: null,
        dniNumber: null,
        shippingAddress: {
          country: null,
          state: null,
          city: null,
          street1: null,
          postalCode: null,
          phone: null
        }
      },
      payer: {
        fullName: null,
        emailAddress: null,
        contactPhone: null,
        dniType: null,
        dniNumber: null,
        billingAddress: {
          country: null,
          state: null,
          city: null,
          street1: null,
          postalCode: null,
          phone: null
        }
      },
      creditCard: {
        number: null,
        securityCode: null,
        expirationDate: null,
        name: null
      },
      debitCard: {
        number: null,
        securityCode: null,
        expirationDate: null,
        name: null
      }
    }
  },
  getters: {
    getCarritoHabilitado: (state) => {
      return state.carritoHabilitado
    },
    getCarritoCantidad: (state) => {
      return state.cantidad
    },
    getProductos: (state) => {
      return state.productos
    },
    getTotal: (state) => {
      return state.total
    },
    getSubtotal: (state) => {
      return state.subtotal
    },
    getPayU: (state) => {
      return state.payU
    },
    getPaypal: (state) => {
      return state.paypal
    },
    getInfo: (state) => {
      return state.info
    },
    getInfoEnvio: (state) => {
      var info = {
        nombre: state.info.buyer.fullName,
        email: state.info.buyer.emailAddress,
        telefono: state.info.buyer.contactPhone,
        tipoDocumento: state.info.buyer.dniType,
        numeroDocumento: state.info.buyer.dniNumber,
        pais: state.info.buyer.shippingAddress.country,
        departamento: state.info.buyer.shippingAddress.department,
        ciudad: state.info.buyer.shippingAddress.city,
        direccion: state.info.buyer.shippingAddress.street1,
        codigoPostal: state.info.buyer.shippingAddress.postalCode
      }
      return info
    }
  },
  mutations: {
    setCarritoHabilitado: (state, estado) => {
      state.carritoHabilitado = estado
    },
    limpiarCarrito: (state) => {
      state.productos = []
      state.cantidad = 0
    },
    setTotal: (state) => {
      state.total = 0
      state.subtotal = 0
    },
    setProductos: (state, productos) => {
      state.productos = productos
    },
    setCantidad: (state, cantidad) => {
      state.cantidad = cantidad
    },
    setProducto: (state, producto) => {
      state.productos.push(producto)
      state.cantidad = state.cantidad + producto.cantidad
      if (state.tipo === 'porcentaje') {
        state.total = Number((state.subtotal * (100 - state.descuento)) / 100)
      } else {
        state.total = state.subtotal - state.descuento
      }
      localStorage.setItem('carrito', JSON.stringify(state.productos))
    },
    unSetProducto: (state, index) => {
      state.subtotal = state.subtotal - state.productos[index].totalProducto
      state.cantidad = state.cantidad - state.productos[index].cantidad
      state.productos.splice(index, 1)
      if (state.tipo === 'porcentaje') {
        state.total = Number((state.subtotal * (100 - state.descuento)) / 100)
      } else {
        state.total = state.subtotal - state.descuento
      }
      localStorage.setItem('carrito', JSON.stringify(state.productos))
    },
    aumentarCantidad: (state, index) => {
      if (state.productos[index].maximaCantidad > state.productos[index].cantidad) {
        state.productos[index].cantidad++
        state.subtotal = state.subtotal + state.productos[index].precio
        state.productos[index].totalProducto = state.productos[index].totalProducto + state.productos[index].precio
        state.cantidad = state.cantidad + 1
        if (state.tipo === 'porcentaje') {
          state.total = Number((state.subtotal * (100 - state.descuento)) / 100)
        } else {
          state.total = state.subtotal - state.descuento
        }
      }
      localStorage.setItem('carrito', JSON.stringify(state.productos))
    },
    disminuirCantidad: ({ commit }, state, index) => {
      if (state.productos[index].cantidad > 1) {
        state.productos[index].cantidad--
        state.subtotal = state.subtotal - state.productos[index].precio
        state.productos[index].totalProducto = state.productos[index].totalProducto - state.productos[index].precio
        state.cantidad = state.cantidad - 1
        if (state.tipo === 'porcentaje') {
          state.total = Number((state.subtotal * (100 - state.descuento)) / 100)
        } else {
          state.total = state.subtotal - state.descuento
        }
        if (state.productos[index].cantidad === 0) {
          commit('setTotal')
        }
      }
      localStorage.setItem('carrito', JSON.stringify(state.productos))
    },
    sumar: (state, precio) => {
      state.subtotal = state.subtotal + precio
      if (state.tipo === 'porcentaje') {
        state.total = Number((state.subtotal * (100 - state.descuento)) / 100)
      } else {
        state.total = state.subtotal - state.descuento
      }
    },
    setDescuento: (state, info) => {
      state.descuento = info.valor
      state.tipo = info.tipo
      if (state.tipo === 'porcentaje') {
        state.total = Number((state.subtotal * (100 - state.descuento)) / 100)
      } else {
        state.total = state.subtotal - state.descuento
      }
    },
    updateDescuento: (state) => {
      if (state.tipo === 'porcentaje') {
        state.total = Number((state.subtotal * (100 - state.descuento)) / 100)
      } else {
        state.total = state.subtotal - state.descuento
      }
    },
    setPayU: (state, estado) => {
      state.payU = estado
    },
    setPaypal: (state, estado) => {
      state.paypal = estado
    },
    setDireccionEnvio: (state, info) => {
      var signature = state.info.apiKey + '~' + state.info.merchantId + '~' + state.info.referenceCode + '~' + state.info.total + '~' + state.info.currency
      state.info.signature = md5(signature)
      state.info.buyer.fullName = info.fullName
      state.info.buyer.emailAddress = info.emailAddress
      state.info.buyer.contactPhone = info.contactPhone
      state.info.buyer.dniType = info.dniType
      state.info.buyer.dniNumber = info.dniNumber
      state.info.buyer.shippingAddress.country = info.country
      state.info.buyer.shippingAddress.department = info.department
      state.info.buyer.shippingAddress.city = info.city
      state.info.buyer.shippingAddress.street1 = info.street1
      state.info.buyer.shippingAddress.postalCode = info.postalCode
      state.info.buyer.shippingAddress.phone = info.contactPhone
      state.info.total = info.total
    }
  },
  actions: {
    anadirCarrito ({ commit, state }, info) {
      if (state.productos[0] !== undefined) {
        var cont = state.productos.length
        for (let i = 0; i < state.productos.length; i++) {
          if (state.productos[i].uid === info.producto.uid) {
            if (state.productos[i].tipo === 'fisico') {
              if (state.productos[i].uidInventario === info.producto.uidInventario) {
                commit('aumentarCantidad', i)
                commit('updateDescuento')
                break
              } else {
                commit('setProducto', info.producto)
                commit('sumar', info.producto.precio)
                commit('updateDescuento')
                commit('setAlerta')
                commit('setTextoAlerta', 'Alerta.ProductoAnadido')
                break
              }
            } else if (state.productos[i].tipo === 'digital') {
              commit('aumentarCantidad', i)
              commit('updateDescuento')
              break
            }
          }
          cont = cont - 1
          if (cont === 0) {
            commit('setProducto', info.producto)
            commit('sumar', info.producto.precio)
            commit('updateDescuento')
            commit('setAlerta')
            commit('setTextoAlerta', 'Alerta.ProductoAnadido')
            break
          }
        }
      } else {
        commit('setProducto', info.producto)
        commit('sumar', info.producto.precio)
        commit('updateDescuento')
        commit('setAlerta')
        commit('setTextoAlerta', 'Alerta.ProductoAnadido')
      }
      localStorage.setItem('carrito', JSON.stringify(state.productos))
    },
    verificarCarrito ({ commit, state }, productos) {
      // console.log(productos)
      var actualizados = []
      var cont = productos.length
      for (let i = 0; i < productos.length; i++) {
        if (productos[i].tipo === 'fisico' || productos[i].tipo === 'digital') {
          firebase.firestore().collection('productos').doc(productos[i].uid).get().then(info => {
            actualizados.push(info.data())
            cont = cont - 1
            // console.log(actualizados)
            if (cont === 0) {
              for (let o = 0; o < actualizados.length; o++) {
                if (productos[i].cantidad !== 0) {
                  var producto = null
                  if (productos[i].tipo === 'fisico') {
                    producto = {
                      uid: actualizados[o].uid,
                      referencia: actualizados[o].referencia,
                      titulo: actualizados[o].titulo,
                      precio: Number(actualizados[o].precioPago),
                      costeEnvio: Number(actualizados[o].costeEnvio),
                      envioIncluido: Boolean(actualizados[o].envioIncluido),
                      dimensiones: actualizados[o].dimensiones,
                      normal: actualizados[o].normal,
                      enrollado: actualizados[o].enrollado,
                      dimensionesEnrollado: actualizados[o].dimensionesEnrollado,
                      imagenPrincipal: actualizados[o].imagenPrincipal,
                      artista: {
                        uid: actualizados[o].artista.uid,
                        nombre: actualizados[o].artista.nombre,
                        pais: actualizados[o].artista.pais,
                        email: actualizados[o].artista.email,
                        codigo: actualizados[o].artista.codigo,
                        codigoPostal: actualizados[o].artista.codigoPostal
                      },
                      subcategoria: actualizados[o].subcategoria,
                      tipo: 'fisico',
                      uidInventario: productos[o].uidInventario
                    }
                    if (actualizados[i].color) {
                      producto.color = productos[o].color
                      if (actualizados[i].talla) {
                        producto.talla = productos[o].talla
                        for (let u = 0; u < actualizados[i].inventario.length; u++) {
                          if (productos[o].color === actualizados[i].inventario[u].color.tituloColor) {
                            if (productos[o].talla === actualizados[i].inventario[u].talla) {
                              producto.maximaCantidad = actualizados[i].inventario[u].cantidad
                              if (producto.maximaCantidad === 0) {
                                continue
                              }
                            }
                          }
                        }
                      }
                    }
                    if (actualizados[i].talla && !actualizados[i].color) {
                      producto.talla = productos[o].talla
                      for (let u = 0; u < productos[i].inventario.length; u++) {
                        if (productos[i].talla === productos[i].inventario[i].talla) {
                          producto.maximaCantidad = productos[i].inventario[i].cantidad
                          if (producto.maximaCantidad === 0) {
                            continue
                          }
                        }
                      }
                    }
                    if (productos[i].cantidad <= actualizados[o].cantidadFisico) {
                      producto.cantidad = productos[i].cantidad
                      producto.totalProducto = Number(producto.cantidad * producto.precio)
                    } else {
                      producto.cantidad = actualizados[o].cantidadFisico
                      producto.totalProducto = Number(producto.cantidad * producto.precio)
                    }
                    commit('setProducto', producto)
                    commit('sumar', producto.totalProducto)
                    commit('updateDescuento')
                  }
                  if (productos[i].tipo === 'digital') {
                    producto = {
                      uid: actualizados[o].uid,
                      titulo: actualizados[o].titulo,
                      precio: Number(actualizados[o].precioPagoDig),
                      costeEnvio: Number(actualizados[o].costeEnvio),
                      envioIncluido: Boolean(actualizados[o].envioIncluido),
                      dimensiones: actualizados[o].dimensiones,
                      normal: actualizados[o].normal,
                      enrollado: actualizados[o].enrollado,
                      dimensionesEnrollado: actualizados[o].dimensionesEnrollado,
                      imagenPrincipal: actualizados[o].imagenPrincipal,
                      artista: {
                        uid: actualizados[o].artista.uid,
                        nombre: actualizados[o].artista.nombre,
                        pais: actualizados[o].artista.pais,
                        email: actualizados[o].artista.email,
                        codigo: actualizados[o].artista.codigo,
                        codigoPostal: actualizados[o].artista.codigoPostal
                      },
                      subcategoria: actualizados[o].subcategoria,
                      tipo: 'digital',
                      cantidad: 1,
                      totalProducto: actualizados[o].precioDigital,
                      archivoDigital: actualizados[o].archivoDigital
                    }

                    if (productos[i].cantidad <= actualizados[o].cantidadDigital) {
                      producto.cantidad = productos[i].cantidad
                      producto.totalProducto = Number(producto.cantidad * producto.precio)
                    } else {
                      producto.cantidad = actualizados[o].cantidadDigital
                      producto.totalProducto = Number(producto.cantidad * producto.precio)
                    }
                    commit('setProducto', producto)
                    commit('sumar', producto.totalProducto)
                    commit('updateDescuento')
                  }
                }
              }
            }
          })
            .catch(error => {
              console.log(error)
            })
        }
      }
    }
  }
}
